import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'

import { useCookie, isBrowser, setCookie, getCookie } from './ui/utils'
import useHasMounted from '../../lib/useHasMounted'
import { getRegistration, urlB64ToUint8Array } from './ServiceWorker'
import { Link } from 'react-router-dom'
import Popup from 'ion-popup'
import popupLogo from '../static/general/hag-popup.svg'

const PushPrompt = () => {
  if (!isBrowser || !('PushManager' in window)) {
    return null
  }
  return <PrivatePushPrompt />
}

const PrivatePushPrompt = () => {
  const hasHydrated = useHasMounted()
  const [promptLater, setPromptLater] = useCookie('PromptLater', false)
  const [havePrompted, setPrompted] = useState(true)
  const [helpPopupVisible, setHelpPopupVisible] = useState(false)
  const subscription = useRef(false)

  const registration = getRegistration()
  useEffect(() => {
    if (registration) {
      registration.pushManager.getSubscription()
        .then(sub => {
          subscription.current = sub
          if (!sub && promptLater !== 'true') {
            setPrompted(false)
          } else {
            setPrompted(true)
          }
        })
        .catch((err) => {
          console.error(`Error during getSubscription(): ${err}`)
        })
    }
  }, [registration])

  const handleLater = React.useCallback(() => {
    setPromptLater(true, { days: 14 })
    setPrompted(true)
  })

  const handleAllow = React.useCallback(() => {
    setPromptLater(true, { days: 14 })
    setPrompted(true)
    if (!subscription.current) {
      registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlB64ToUint8Array(process.env.RAZZLE_SERVERKEY)
      })
        .then(function (sub) {
          console.log('User IS now subscribed.')
          subscription.current = sub
          if (getCookie('GeneralNotificationsSub') === '') {
            const generalSub = sub
            generalSub.topic = ''
            axios.post(process.env.RAZZLE_PUSH_SERVICE + '/register', JSON.stringify({ subscription: generalSub, titleKey: process.env.RAZZLE_TITLE_KEY }), {
              headers: {
                'Content-type': 'application/json'
              }
            })
              .then((response) => {
                setCookie('GeneralNotificationsSub', new Date().toISOString(), { days: 30 })
                console.log('Subscribed to general notifications. ', response.data)
              })
              .catch((err) => {
                console.error('Error subscribing to general notifications. ', err.message)
              })
          }
          return axios.post(process.env.RAZZLE_PUSH_SERVICE + '/register', JSON.stringify({ subscription: sub, titleKey: process.env.RAZZLE_TITLE_KEY }), {
            headers: {
              'Content-type': 'application/json'
            }
          })
        })
        .catch(function (err) {
          console.log('Failed to subscribe the user: ', err)
          setHelpPopupVisible(true)
          subscription.current = false
        })
    }
  })

  if (!hasHydrated || promptLater === 'true') {
    return null
  }
  if (havePrompted && !helpPopupVisible) {
    return null
  }
  return (
    <>
      {helpPopupVisible &&
        <Popup visible>
          <div className='push-notification'>
            <div>
              <img src={popupLogo} alt={process.env.RAZZLE_SITE_NAME} />
            </div>
            <div>
              <p>Small problem..</p>
              <p>You have chosen to block notifications.</p>
              <p>To follow stories requires you to enable notifications in your browser settings.</p>
              <div>
                <Link onClick={() => setHelpPopupVisible(false)} to='/help'>Help</Link>
                <button onClick={() => setHelpPopupVisible(false)}>OK</button>
              </div>
            </div>
          </div>
        </Popup>}
      {!helpPopupVisible &&
        <Popup visible>
          <div className='push-notification'>
            <div>
              <img src={popupLogo} alt={process.env.RAZZLE_SITE_NAME} />
            </div>
            <div>
              <p>Get the latest push notifications in design and decor, travel inspiration and recipe ideas from around the world.</p>
              <p>You can turn these off at any time.</p>
              <div>
                <button onClick={handleLater}>Later</button>
                <button onClick={handleAllow}>Allow</button>
              </div>
            </div>
          </div>
        </Popup>}
    </>
  )
}

export default PushPrompt
